"use strict";
// Previously named waitFor
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTaskFinished = void 0;
const isTaskFinished = (conditionFunction) => {
    const poll = (resolve) => {
        if (conditionFunction()) {
            resolve();
        }
        else {
            setTimeout(() => poll(resolve), 400);
        }
    };
    return new Promise(poll);
};
exports.isTaskFinished = isTaskFinished;
